import { ComputedQueryFull, FiltersMap } from '@wix/bex-core';
import { ReactElement } from 'react';

export interface BulkActionModalRenderPropParams<T, F extends FiltersMap> {
  openModal: () => void;
  closeModal: () => void;
  closeModalAndScrollTop: () => void;
  readonly isModalOpen: boolean;
  readonly isSelectAll: boolean;
  readonly selectedValues: T[];
  readonly uncheckedValues: T[];
  scrollToTop: () => void;
  query: ComputedQueryFull<F>;
}

export type BulkActionModalRenderProp<T, F extends FiltersMap> = (
  params: BulkActionModalRenderPropParams<T, F>,
) => ReactElement;
